import React from "react";

const Loader = () => {
    return (
        <>
            <div className="loading-overlay">
                <div className="loader--ripple">
                    <div></div>
                    <div></div>
                </div>
            </div>
        </>
    )
}

export default Loader;